import { useCallback } from 'react';

import { useLanguage } from '../../contexts/language';
import { useNoteSaves } from '../../contexts/note-saves';
import { notesUnsaved, useSignOut } from '../../hooks/sign-out';

import styles from './style.module.css';

// The shared sign-out transition where notes are written (#134): while it
// runs, why the notes cannot be edited; when it stopped, the reason, with
// signing out again and, for a note that could not be saved, signing out
// without it. A person who left Settings while waiting can finish or give up
// here. Nothing shows otherwise.
export function PendingSignOut() {
  const { text, translate } = useLanguage();
  const { signingOut, signOutFailure } = useNoteSaves();
  const signOut = useSignOut();

  // The reason is shown from the shared transition, so the rejection itself
  // needs nothing more here.
  const onRetry = useCallback(function() {
    return signOut({ discard: false }).catch(function() {});
  }, [ signOut ]);

  const onDiscard = useCallback(function() {
    return signOut({ discard: true }).catch(function() {});
  }, [ signOut ]);

  if (signingOut === true) {
    return <p className={ styles.pending } role='status'>{ text.signingOutNotes }</p>;
  }

  if (signOutFailure == null) {
    return null;
  }

  let discard = null;

  if (signOutFailure === notesUnsaved) {
    discard = <button className={ styles.button } type='button' onClick={ onDiscard }>{ text.signOutWithoutNote }</button>;
  }

  return (
    <div className={ styles.failed } role='alert'>
      <p className={ styles.text }>{ translate(signOutFailure) }</p>

      <div className={ styles.actions }>
        <button className={ styles.button } type='button' onClick={ onRetry }>{ text.signOutAgain }</button>

        { discard }
      </div>
    </div>
  );
}
